import { useEffect, useState } from 'react';
import { useFund } from '../context/FundContext';
import FundDateBar from '../components/FundDateBar';
import { Loading } from '../components/Loader';
import { api } from '../api';
import { money } from '../format';

// Renders the balanceSheet endpoint (confirmed working) as a classic
// Assets / Liabilities / Capital statement.
function Section({ title, rows, total }) {
  return (
    <div className="panel">
      <div className="section-head">
        <h3>{title}</h3>
        <span className="section-total">{money(total)}</span>
      </div>
      <table className="table">
        <tbody>
          {(rows || []).map((r) => (
            <tr key={r.nameOfGLAccount}>
              <td>{r.nameOfGLAccount}</td>
              <td className="num">{money(r.netAmount)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default function Accounting() {
  const { fund, date } = useFund();
  const [bs, setBs] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!fund || !date) return;
    setError(null);
    setLoading(true);
    api.balanceSheet(fund, date)
      .then(setBs)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [fund, date]);

  return (
    <div>
      <FundDateBar />
      <h2 className="page-title">Balance Sheet</h2>
      {error && <div className="error">Error: {error}</div>}
      {loading && <Loading label="Loading balance sheet…" />}
      {bs && !loading && (
        <div className="dual-grid">
          <Section title="Assets & Cash" rows={bs.AssetsAndCash} total={bs.TotalAssets} />
          <div>
            <Section title="Liabilities" rows={bs.Liabilities} total={bs.TotalLiabilities} />
            <Section
              title="Capital / Net Assets"
              rows={bs.NetAssets}
              total={(bs.NetAssets || []).reduce((a, r) => a + (Number(r.netAmount) || 0), 0)}
            />
          </div>
        </div>
      )}
    </div>
  );
}
